import Cals from "./components/Cals";



function App() {
  return (
    <>
    <Cals/>
    </>
  );
}

export default App;
